import React, { useEffect, useMemo, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { useNotaire } from "../context/NotaireContext";
import { toast } from "react-toastify";
import { format } from "date-fns";
import { CalendarStyle } from "../style/Calendrier";
import {
    Dialog,
    DialogPanel,
    DialogBackdrop,
    DialogTitle,
} from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

function formatDateFR(date) {
    return format(date, "dd/MM/yyyy");
}

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

const PanelNotaireIndisponibilites = () => {
    const context = useNotaire();
     console.log("Indispos context:", context);
    const etudeId = context?.infoEtude?.id;

    const [indispos, setIndispos] = useState([]);
    const [loading, setLoading] = useState(false);

    const [selectedRange, setSelectedRange] = useState([]);
    const [allDay] = useState(true);
    const [isSaving, setIsSaving] = useState(false);

    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const [deleteOpen, setDeleteOpen] = useState(false);
    const [selectedDeleteId, setSelectedDeleteId] = useState(null);

    const API_KEY = "dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02";
    const BASE_ID = "appD48APNaGA4GN0B";
    const TABLE = "indisponibilites_notaire";

    const fetchData = async () => {
        if (!etudeId) return;
        setLoading(true);
        try {
            const emailForIndispos = (context.user?.role === 'secretaire' && context.user?.email_notaire)
                ? context.user.email_notaire
                : context.user?.email;
            const res = await fetch(
                `https://api.airtable.com/v0/${BASE_ID}/${TABLE}?filterByFormula=email_from_etude="${emailForIndispos}"&sort[0][field]=debut`,
                {
                    headers: {
                        Authorization: `Bearer patfRIUbOM9xqwLV2.${API_KEY}`,
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                }
            );
            const data = await res.json();
            console.log("Indispos fetched:", data);
            setIndispos(data.records || []);
        } catch (e) {
            console.error(e);
            toast.error("Erreur chargement indisponibilités");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [etudeId]);

    const handleSelect = (value) => {
        if (Array.isArray(value)) {
            setSelectedRange(value);
        } else {
            setSelectedRange([value, value]);
        }
    };

    const startDate = selectedRange[0];
    const endDate = selectedRange[1] || selectedRange[0];

    const label = useMemo(() => {
        if (!startDate) return "";
        if (startDate.getTime() === endDate.getTime()) {
            return `Le ${formatDateFR(startDate)}`;
        }
        return `Du ${formatDateFR(startDate)} au ${formatDateFR(endDate)}`;
    }, [startDate, endDate]);

    const handleSave = async () => {
        if (!startDate) {
            toast.error("Sélectionnez une date");
            return;
        }

        setIsSaving(true);
        try {
            const start = new Date(startDate);
            start.setHours(0, 0, 0, 0);

            const end = new Date(endDate);
            end.setHours(23, 59, 0, 0);

            const payload = {
                fields: {
                    etude: [String(etudeId)],
                    debut: start.toISOString(),
                    fin: end.toISOString(),
                    all_day: allDay,
                },
            };

            const res = await fetch(
                `https://api.airtable.com/v0/${BASE_ID}/${TABLE}`,
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer patfRIUbOM9xqwLV2.${API_KEY}`,
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );

            const data = await res.json();

            if (!res.ok) {
                console.error(data);
                toast.error("Erreur enregistrement");
                return;
            }

            setIndispos((prev) => [...prev, data]);
            setSelectedRange([]);
            setIsDrawerOpen(false);
            toast.success("Indisponibilité enregistrée");
        } catch (e) {
            console.error(e);
            toast.error("Erreur réseau");
        } finally {
            setIsSaving(false);
        }
    };

    const confirmDelete = async () => {
        if (!selectedDeleteId) return;

        try {
            await fetch(
                `https://api.airtable.com/v0/${BASE_ID}/${TABLE}/${selectedDeleteId}`,
                {
                    method: "DELETE",
                    headers: {
                        Authorization: `Bearer patfRIUbOM9xqwLV2.${API_KEY}`,
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                }
            );

            setIndispos((prev) => prev.filter((i) => i.id !== selectedDeleteId));
            setDeleteOpen(false);
            setSelectedDeleteId(null);
            toast.success("Indisponibilité supprimée");
        } catch (e) {
            toast.error("Erreur suppression");
        }
    };

    return (
        <>
            {/* LISTE */}
            <div className="mt-4 rounded-lg bg-white shadow-sm p-4">
                <div className="flex items-center justify-between mb-2">
                    <h3 className="text-sm font-semibold text-gray-900">
                        Indisponibilités enregistrées
                    </h3>
                    <button
                        onClick={() => {
                            setSelectedRange([]);
                            setIsDrawerOpen(true);
                        }}
                        className="px-3 py-1.5 rounded-md bg-indigo-600 text-white text-sm font-medium hover:bg-indigo-700"
                    >
                        + Ajouter une indispo
                    </button>
                </div>
                <p className="text-sm text-gray-600 mb-4">
                    La prise de rendez-vous n'est pas possible pendant ces périodes d'indisponibilités.
                </p>

                {loading ? (
                    <p className="text-sm text-gray-500">Chargement...</p>
                ) : indispos.length === 0 ? (
                    <p className="text-sm text-gray-500">Aucune indisponibilité</p>
                ) : (
                    <ul className="divide-y">
                        {indispos.map((item) => {
                            const f = item.fields;
                            const start = new Date(f.debut);
                            const end = new Date(f.fin);

                            return (
                                <li
                                    key={item.id}
                                    className="py-3 px-2 flex justify-between items-center border border-gray-100 rounded-lg mb-2"
                                >
                                    <p className="text-sm font-medium">
                                        {formatDateFR(start)}
                                        {start.getTime() !== end.getTime() &&
                                            ` → ${formatDateFR(end)}`}
                                    </p>
                                    <button
                                        onClick={() => {
                                            setSelectedDeleteId(item.id);
                                            setDeleteOpen(true);
                                        }}
                                        className="text-red-500 text-sm"
                                    >
                                        Supprimer
                                    </button>
                                </li>
                            );
                        })}
                    </ul>
                )}
            </div>

            {/* DRAWER AJOUT */}
            <Dialog open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} className="relative z-10">
                <DialogBackdrop className="fixed inset-0 bg-gray-500 bg-opacity-75" />

                <div className="fixed inset-0 overflow-hidden">
                    <div className="absolute inset-0 overflow-hidden">
                        <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                            <DialogPanel className="pointer-events-auto w-screen max-w-md transform bg-white shadow-xl">
                                <div className="flex h-full flex-col py-3">
                                    <div className="px-4 sm:px-6 flex items-start justify-between">
                                        <DialogTitle className="text-lg font-medium text-gray-900">
                                            Ajouter une indisponibilité
                                        </DialogTitle>
                                        <button
                                            onClick={() => setIsDrawerOpen(false)}
                                            className="text-gray-400 hover:text-gray-500"
                                        >
                                            <XMarkIcon className="size-6" />
                                        </button>
                                    </div>

                                    <div className="relative mt-4 flex-1 px-4 sm:px-6 overflow-y-auto">
                                        <p className="text-sm text-gray-600 mb-4">
                                            Sélectionnez un jour ou une période. La prise de rendez-vous sera bloquée durant cette période.
                                        </p>

                                        <CalendarStyle>
                                            <Calendar
                                                selectRange
                                                onChange={handleSelect}
                                                value={selectedRange}
                                                tileDisabled={({ date }) => {
                                                    const today = new Date();
                                                    today.setHours(0, 0, 0, 0);
                                                    return date < today;
                                                }}
                                                className="border rounded-lg p-2 w-full"
                                            />
                                        </CalendarStyle>

                                        {startDate && (
                                            <div className="mt-4 p-4 bg-gray-50 rounded-lg border border-gray-200">
                                                <p className="text-sm font-medium text-gray-900">{label}</p>
                                                <p className="text-sm text-gray-500 mt-1">
                                                    {startDate.getTime() === endDate.getTime()
                                                        ? "Indisponible toute la journée"
                                                        : "Indisponible sur toute la période"}
                                                </p>
                                            </div>
                                        )}
                                    </div>

                                    <div className="px-4 sm:px-6 border-t-2 border-gray-200 py-3">
                                        <button
                                            onClick={handleSave}
                                            disabled={!startDate || isSaving}
                                            className={classNames(
                                                "w-full py-2 rounded font-semibold",
                                                !startDate || isSaving
                                                    ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                                                    : "bg-indigo-600 text-white hover:bg-indigo-700"
                                            )}
                                        >
                                            {isSaving ? "Enregistrement..." : "Enregistrer l'indisponibilité"}
                                        </button>
                                    </div>
                                </div>
                            </DialogPanel>
                        </div>
                    </div>
                </div>
            </Dialog>

            {/* MODAL SUPPRESSION */}
            <Dialog open={deleteOpen} onClose={setDeleteOpen} className="relative z-10">
                <DialogBackdrop className="fixed inset-0 bg-gray-500/75" />

                <div className="fixed inset-0 flex items-center justify-center p-4">
                    <DialogPanel className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
                        <DialogTitle className="text-lg font-semibold">
                            Supprimer cette indisponibilité ?
                        </DialogTitle>

                        <p className="text-sm text-gray-500 mt-2">
                            Cette action est irréversible.
                        </p>

                        <div className="mt-4 flex justify-end gap-2">
                            <button
                                onClick={() => setDeleteOpen(false)}
                                className="bg-gray-100 px-4 py-2 rounded"
                            >
                                Annuler
                            </button>
                            <button
                                onClick={confirmDelete}
                                className="bg-red-600 text-white px-4 py-2 rounded"
                            >
                                Supprimer
                            </button>
                        </div>
                    </DialogPanel>
                </div>
            </Dialog>
        </>
    );
};

export default PanelNotaireIndisponibilites;
